/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NotificationBellIcon16Light } from './NotificationBellIcon16Light';
import { NotificationBellIcon16Regular } from './NotificationBellIcon16Regular';
import { NotificationBellIcon16Solid } from './NotificationBellIcon16Solid';
import { NotificationBellIcon20Light } from './NotificationBellIcon20Light';
import { NotificationBellIcon20Regular } from './NotificationBellIcon20Regular';
import { NotificationBellIcon20Solid } from './NotificationBellIcon20Solid';
import { NotificationBellIcon24Regular } from './NotificationBellIcon24Regular';
import { NotificationBellIcon24Solid } from './NotificationBellIcon24Solid';
import { NotificationBellIcon32Regular } from './NotificationBellIcon32Regular';
import { NotificationBellIcon64Regular } from './NotificationBellIcon64Regular';
var sizes = {
    16: {
        light: NotificationBellIcon16Light,
        regular: NotificationBellIcon16Regular,
        solid: NotificationBellIcon16Solid,
    },
    20: {
        light: NotificationBellIcon20Light,
        regular: NotificationBellIcon20Regular,
        solid: NotificationBellIcon20Solid,
    },
    24: {
        regular: NotificationBellIcon24Regular,
        solid: NotificationBellIcon24Solid,
    },
    32: {
        regular: NotificationBellIcon32Regular,
    },
    64: {
        regular: NotificationBellIcon64Regular,
    },
};
export var NotificationBellIcon = forwardRef('NotificationBellIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
